import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Sends a Google Analytics page_view on SPA route changes.
 * Requires gtag snippet present in index.html.
 */
const RouteAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip if GA is not loaded
    const gtag = (window as any).gtag as undefined | ((...args: unknown[]) => void);
    if (!gtag) return;

    // Respect consent: only send page_view if analytics allowed
    const consent = localStorage.getItem('cookieConsent');
    if (consent !== 'all' && consent !== 'essential') return;

    // Send page_view with current path
    gtag('event', 'page_view', {
      page_path: location.pathname + (location.search || ''),
    });
  }, [location.pathname, location.search]);

  return null;
};

export default RouteAnalytics;


